import { APP_VARIABLE_DATA_TYPES } from "../../constants/app.constants.js";
import { validateJsonValue } from "../utils/json.validator.js";
import { isEmpty } from "../utils/utils.js";

export const errorMsg = (data, err) => {
  return {
    _req: { ...data },
    resp: {
      isError: true,
      message: "some error occured",
      errorStr: err
      //...err
    }
  };
};

export const msgData = (reqData, respData = {}) => {
  return {
    _req: { ...reqData },
    resp: { ...respData }
  };
};

export const isAndroid = () => {
  return navigator.userAgent.toLowerCase().indexOf("android") > -1;
};

export const isIOS = () => {
  return ["iPad", "iPhone", "iPod"].includes(navigator.platform);
};

export const isMobile = () => {
  return isAndroid() || isIOS();
};

export function isSharedArrayBuffer(buffer) {
  // eslint-disable-next-line no-undef
  return buffer instanceof SharedArrayBuffer;
}

export function getValueFromObject(parentValue, path) {
  return path.reduce((acc, key) => acc[key], parentValue);
}

export function isJsonVariable(type = "") {
  return type === APP_VARIABLE_DATA_TYPES.JSON;
}

function validateJsonVariable({ value, varDef, nestedPath = [], oldValue }) {
  let validationStatus = validateJsonValue({
    value,
    path: nestedPath,
    schema: varDef.Schema,
    oldValue
  });

  if (!validationStatus.isValid) throw validationStatus.error;

  return validationStatus.value;
}

export function validateAndUpdateVariable({
  varDef,
  variableName,
  value,
  // nestedPath for json nested value update
  nestedPath = [],
  // should return variableValue
  getVariable = (varName) => {},
  // should return udpated value
  setVariable = (obj) => {}
}) {
  function updateVariable(key, value) {
    return setVariable({
      [key]: value
    });
  }

  if (isJsonVariable(varDef.DataType)) {
    let newValue = validateJsonVariable({
      oldValue: getVariable(variableName),
      value,
      varDef,
      nestedPath
    });

    let updatedValue = updateVariable(variableName, newValue);

    if (!isEmpty(nestedPath)) {
      let nestedKey = [variableName, ...nestedPath].join(".");
      return {
        [nestedKey]: getValueFromObject(updatedValue[variableName], nestedPath)
      };
    }

    return updatedValue;
  } else {
    return updateVariable(variableName, value);
  }
}
